// Inert blocks pointer, keyboard, focus and assistive-technology interaction.
// Keep scrolling available and leave the Lino pane (including Stop) operable.
export function lockEditor(root = document) {
  const originals = new Map();
  const apply = () => {
    const locked = new Set();
    let branch = root.querySelector('#sidebar-assistant');
    // Walk the Lino branch: everything alongside it is inert, including
    // portaled Slate toolbars, dialogs and editor controls outside #main.
    while (branch && branch !== root.body) {
      for (const sibling of branch.parentElement.children) {
        if (sibling !== branch) locked.add(sibling);
      }
      branch = branch.parentElement;
    }
    originals.forEach((wasInert, node) => {
      if (!locked.has(node)) {
        if (!wasInert) node.removeAttribute('inert');
        originals.delete(node);
      }
    });
    locked.forEach((node) => {
      if (!originals.has(node)) originals.set(node, node.hasAttribute('inert'));
      node.setAttribute('inert', '');
    });
  };
  apply();
  const observer = new MutationObserver(apply);
  observer.observe(root.body, { childList: true, subtree: true });
  // Volto also listens for document-wide Save/Undo/Redo shortcuts.
  const onKeyDown = (event) => {
    if (!(event.metaKey || event.ctrlKey)) return;
    if (!['s', 'z', 'y'].includes(event.key.toLowerCase())) return;
    event.stopImmediatePropagation();
    if (
      event.key.toLowerCase() === 's' ||
      !event.target.closest?.('#sidebar-assistant textarea')
    ) {
      event.preventDefault();
    }
  };
  root.addEventListener('keydown', onKeyDown, true);
  return () => {
    observer.disconnect();
    root.removeEventListener('keydown', onKeyDown, true);
    originals.forEach((wasInert, node) => {
      if (!wasInert) node.removeAttribute('inert');
    });
  };
}
